import { Spinner } from '@uplift/ui-v2';
import { Suspense } from 'react';
import { MatchingProfileData, MatchingProvidersType, PsychAppointmentBookingSource } from '@uplift/api';
import { ConfirmSession } from './ConfirmSession';
import { ConnectStep } from './ConnectStep';
import { PsychiatristProfile } from './PsychiatristProfile';
import { PsychiatryMatchingContextContainer, usePsychiatryMatchingContext } from './psychiatry-matching-context';
import { StartStep } from './StartStep';
import { useStyles } from './styles';

export type StepViewProps = {
  disabled?: boolean;
  isDrawer?: boolean;
};

const StepView: React.VFC<StepViewProps> = ({ disabled, isDrawer }) => {
  const { classes } = useStyles({ isDrawer });
  const { state } = usePsychiatryMatchingContext();

  switch (state.step) {
    case 'start':
      return (
        <div className={classes.container}>
          <StartStep disabled={disabled} />
        </div>
      );
    case 'connect':
      return (
        <div className={classes.container}>
          <ConnectStep />
        </div>
      );
    case 'profile':
      return <PsychiatristProfile />;
    case 'confirm':
      return (
        <div className={classes.container}>
          <ConfirmSession />
        </div>
      );
  }
};

export type PsychiatryMatchingProps = {
  stateId: string;
  patientName: string;
  patientId: string;
  onDone: (complete: boolean) => void;
  providers?: MatchingProfileData[];
  matchingProvidersType?: MatchingProvidersType;
  isDrawer?: boolean;
  source?: PsychAppointmentBookingSource;
};

export const PsychiatryMatching: React.VFC<PsychiatryMatchingProps> = ({ patientName, patientId, providers, onDone, source, stateId, isDrawer = false, matchingProvidersType }) => {

  return (
    <PsychiatryMatchingContextContainer
      stateId={stateId}
      patientName={patientName}
      patientId={patientId}
      providers={providers}
      matchingProvidersType={matchingProvidersType}
      onDone={onDone}
      isDrawer={isDrawer}
      source={source}
    >
      <Suspense fallback={<Spinner />}>
        <StepView disabled={!providers.length} isDrawer={isDrawer} />
      </Suspense>
    </PsychiatryMatchingContextContainer>
  );
};
